export const DoorStatus = {
  Open: 'Open',
  Drop: 'Drop',
  Pending: 'Pending',
  Live: 'Live',
  OutOfService: 'OutOfService',
  Working: 'Working',
};

export type DoorStatus = (typeof DoorStatus)[keyof typeof DoorStatus];
